import PhotoAlias from './photoalias'

export default PhotoAlias